import React, { ReactNode } from 'react';
import { SceneState } from '../../types/reel';
import { easeOut, progress } from '../../utils/reelMath';
interface SceneLayerProps {
  time: number;
  start: number;
  end: number;
  fade?: number;
  className?: string;
  children: (state: SceneState) => ReactNode;
}

/**
 * A full-frame layer that morphs in (opacity + soft blur + settle from 1.025 scale)
 * over the previous scene, and fades out once fully covered.
 */
export function SceneLayer({
  time,
  start,
  end,
  fade = 0.5,
  className = '',
  children
}: SceneLayerProps) {
  const enter = easeOut(progress(time, start - fade, start));
  const exit = progress(time, end, end + fade);
  const opacity = Math.min(enter, 1 - exit);
  const visible = opacity > 0.001;
  const p = progress(time, start - fade, end + fade);
  return <div className={`absolute inset-0 overflow-hidden ${className}`} style={{
    opacity,
    visibility: visible ? 'visible' : 'hidden',
    transform: `scale(${1.025 - 0.025 * enter})`,
    filter: enter < 1 ? `blur(${(1 - enter) * 10}px)` : 'none'
  }} data-id="element-311" data-mp="2y2iwckpxke1j">
      {children({
      local: time - start,
      p,
      enter
    })}
    </div>;
}